import TextFieldStyled from "@/components/TextFieldStyled";
import Typography from "@mui/material/Typography";

const NetworkLocationFormSocialMedia = ({ formValues, onChange }) => {
  const handleInputChanged = (event, value) => {
    if (onChange && typeof onChange === "function") {
      onChange(event, value);
    }
  };

  return (
    <>
      <Typography
        variant="h4"
        component="p"
        color="common.black"
        sx={{ mt: 4 }}
      >
        {formValues?.category?.id !== "bands"
          ? "Links & Social Media"
          : "Eure Website"}
      </Typography>
      <TextFieldStyled
        required={formValues?.category?.id === "4"}
        type="url"
        name="website"
        label="Website"
        placeholder="https://deineseite.com"
        onChange={handleInputChanged}
      />
      {formValues?.category?.id !== "bands" && (
        <>
          <TextFieldStyled
            type="url"
            name="link_facebook"
            label="Facebook"
            placeholder="https://facebook.com/deineseite"
            onChange={handleInputChanged}
          />
          <TextFieldStyled
            type="url"
            name="link_instagram"
            label="Instagram"
            placeholder="https://instagram.com/deineband"
            onChange={handleInputChanged}
          />
          <TextFieldStyled
            type="url"
            name="link_tiktok"
            label="TikTok"
            placeholder="https://tiktok.com/deineband"
            onChange={handleInputChanged}
          />
          <TextFieldStyled
            type="url"
            name="link_youtube"
            label="Youtube"
            placeholder="https://youtube.com/channel/deineband"
            onChange={handleInputChanged}
          />
          <TextFieldStyled
            type="url"
            name="link_bandcamp"
            label="Bandcamp"
            placeholder="https://deineband.bandcamp.com"
            onChange={handleInputChanged}
          />
          <TextFieldStyled
            type="url"
            name="link_spotify"
            label="Spotify"
            placeholder="https://open.spotify.com/artist/deineurl"
            onChange={handleInputChanged}
          />
          <TextFieldStyled
            type="url"
            name="link_soundcloud"
            label="Soundcloud"
            placeholder="https://soundcloud.com/deineurl"
            onChange={handleInputChanged}
          />
        </>
      )}
    </>
  );
};

export default NetworkLocationFormSocialMedia;
